// use if it is required for 3rd party libraries
export enum DateFnsFormatEnum {
    YEAR = 'yyyy',
    YEAR_MONTH = 'yyyy-MM',
    YEAR_MONTH_DAY = 'yyyy-MM-dd',
}
